module.exports = __webpack_public_path__ + "static/media/11.5ee59905.jpg";